<template>
  <div>
    <viewTable
        ref="viewTable"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="mergeMaterials"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="true" type="primary" :disabled="!selection.length" @click="printOrder">
          发料单打印
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="$refs.viewTable.loadData(1)">
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.purchaseOrderNos" placeholder="请输入采购单号" clearable/>
          </el-form-item>
          <el-form-item label="发料单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入发料单号" clearable/>
          </el-form-item>
          <el-form-item label="供应商编码">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编码" clearable/>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.statusName === '已提交'"
            @click="submit(scope.row.pkId)">
          提交
        </el-button>
      </template>
    </viewTable>
    <merge-material-edit ref="mergeOrderEdit" @save-succee="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import MergeMaterialEdit from "@/views/StoreManagement/MergeMaterialOrder/MergeMaterialEdit";

  export default {
    name: "MergeMaterialOrder",
    components: {MergeMaterialEdit, viewTable},
    data() {
      return {
        selection: [],
        subAuth: this.$auth(551),
        submitLoading: false,
        createTimeRange: [],
        ids: [],
        filter: {
          warehouseName: "",
          warehouseNo: "",
          supplierNo: "",
          createTimeBegin: "",
          createTimeEnd: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "billNo",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.mergeOrderEdit.open(params.row.pkId);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
          tooltip: true,
            key: "purchaseOrderNos",
            align: "center",
          },
          {
          tooltip: true,
            key: "creatorName",
            align: "center",
          },
          {
          tooltip: true,
            key: "createTime",
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      selectHandle(selection) {
        this.selection = selection;
        this.ids = [];
        this.selection.forEach((item) => {
          this.ids.push(item.pkId);
        });
      },
      submit(id) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"})
          .then(() => {
            this.$http.get("basic", `mergeMaterials/submit/${id}`).then((resp) => {
              if (resp.success) {
                this.$message.success("提交成功");
                this.loadData(1);
              }
            });
          }).catch(() => {
          });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      // 工单打印
      printOrder() {
        if (this.selection.length === 0) {
          this.$confirm("请至少选择一条数据打印", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.gotoPrint(1);
      },
      gotoPrint(printType) {
        const routeUrl = this.$router.resolve({
          path: "/mergeOrderPrint",
          query: {
            ids: JSON.stringify(this.ids),
            printType,
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
    },
  };
</script>
